import React from 'react'
import { Link } from 'react-router'

import Icon from '@hixme-ui/icon'
import Button from '@hixme-ui/button'
import useOutsideClick from 'hooks/useOutsideClick'

const mainButtonStyles = {
  borderTopRightRadius: '0',
  borderBottomRightRadius: '0',
}
const toggleButtonStyles = {
  borderTopLeftRadius: '0',
  borderBottomLeftRadius: '0',
  marginLeft: '-1px',
  minWidth: 'auto',
  padding: '5px',
}

const arrowIconStyles = {
  position: 'relative',
  bottom: '7px',
}

export type SplitButtonProps = {
  title: string
  url?: string
  style?: React.CSSProperties
  disabled?: boolean
  toggleStyles?: React.CSSProperties
  persist?: boolean
  elevateWhenOpen?: boolean
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onSelect?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  children: React.ReactNode
}

const SplitButton = ({
  title,
  url,
  style,
  disabled,
  toggleStyles,
  onClick,
  onSelect,
  persist = false,
  elevateWhenOpen = false,
  children,
}: SplitButtonProps) => {
  const { ref, isVisible, setIsVisible } = useOutsideClick(false)

  const _onClick = (e) => {
    if (onClick) {
      onClick(e)
    } else if (onSelect) {
      onSelect(e)
    } else {
      setIsVisible((prev) => !prev)
    }
  }

  return (
    <div
      style={{
        display: 'inline-flex',
        justifyContent: 'center',
        position: 'relative',
        whiteSpace: 'nowrap',
        ...(elevateWhenOpen ? { zIndex: isVisible ? 1000 : 'auto' } : {}),
      }}
      ref={ref}
    >
      {url ? (
        <Link to={url}>
          <Button
            mini
            outline
            style={{ ...mainButtonStyles, ...style }}
            disabled={disabled}
            onClick={_onClick}
          >
            {title}
          </Button>
        </Link>
      ) : (
        <Button
          mini
          outline
          style={{ ...mainButtonStyles, ...style }}
          disabled={disabled}
          onClick={_onClick}
        >
          {title}
        </Button>
      )}
      <Button
        mini
        outline
        style={{ ...toggleButtonStyles, ...toggleStyles }}
        disabled={disabled}
        onClick={() => setIsVisible((prev) => !prev)}
      >
        <Icon arrowDown light size={0.8} style={arrowIconStyles} />
      </Button>
      {persist ? (
        <div style={{ visibility: isVisible ? 'visible' : 'hidden' }}>
          {children}
        </div>
      ) : isVisible ? (
        children
      ) : null}
    </div>
  )
}

export default SplitButton
